import { render, staticRenderFns } from "./EditAdvertisingInfo.vue?vue&type=template&id=768131ec"
import script from "./EditAdvertisingInfo.vue?vue&type=script&lang=js"
export * from "./EditAdvertisingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports